"use client";

import { Info } from "lucide-react";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function InsuranceAndFunding() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const insuranceProviders = [{
    id: 1,
    name: "Aetna",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1541246/img/aetna_insurance_logo.png",
    eligibility: "Covers in-home and school-based ABA therapy for children ages 2-18"
  }, {
    id: 2,
    name: "Blue Cross Blue Shield",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1541246/img/bcbs_insurance_logo.png",
    eligibility: "Requires prior authorization; covers medically necessary ABA services"
  }, {
    id: 3,
    name: "Cigna",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1541246/img/cigna_insurance_logo.png",
    eligibility: "Covers ABA therapy with BCBA supervision for eligible members"
  }, {
    id: 4,
    name: "UnitedHealthcare",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1541246/img/united_healthcare_logo.png",
    eligibility: "Provides coverage for diagnostic and therapeutic ABA services"
  }, {
    id: 5,
    name: "Humana",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1541246/img/humana_insurance_logo.png",
    eligibility: "Covers ABA therapy for autism spectrum disorder with referral"
  }, {
    id: 6,
    name: "Tricare",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1541246/img/tricare_insurance_logo.png",
    eligibility: "Comprehensive ABA coverage for military families and dependents"
  }, {
    id: 7,
    name: "Medicaid Florida",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1541246/img/florida_medicaid_logo.png",
    eligibility: "State-funded ABA coverage for eligible children with autism"
  }, {
    id: 8,
    name: "Anthem",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1541246/img/anthem_insurance_logo.png",
    eligibility: "Covers evidence-based ABA therapy with clinical documentation"
  }];
  return <section id="insurance-funding" ref={ref} className={`bg-dark-background py-16 lg:py-24 transition-opacity duration-[var(--duration-medium)] ${isVisible ? "opacity-100" : "opacity-0"}`}>
      <div className="container mx-auto px-4 max-w-7xl">
        <div className="text-center mb-12">
          <h2 className="text-foreground-dark mb-4">Insurance & Funding</h2>
          <p className="text-foreground-dark/80 text-lg max-w-3xl mx-auto">
            We accept a variety of insurance plans to make ABA therapy accessible for your family. Contact us to verify your coverage.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8 items-center justify-items-center">
          {insuranceProviders.map((provider, i) => <div key={provider.id} data-index={i} className="flex flex-col items-center gap-3 group">
              <div className="relative bg-white/95 rounded-[var(--radius-lg)] p-6 w-full aspect-[4/3] flex items-center justify-center transition-all duration-[var(--duration-medium)] hover:scale-[1.02] hover:shadow-medium">
                <img src={provider.logo} alt={`${provider.name} logo`} className="max-w-full max-h-full object-contain grayscale group-hover:grayscale-0 transition-all duration-[var(--duration-medium)]" />
              </div>
              
              <Tooltip>
                <TooltipTrigger className="inline-flex items-center gap-1.5 text-foreground-dark/70 hover:text-foreground-dark transition-colors duration-[var(--duration-fast)] focus-ring">
                  <Info className="w-4 h-4" />
                  <span className="text-sm">Eligibility Info</span>
                </TooltipTrigger>
                <TooltipContent className="max-w-xs">
                  <p className="text-xs leading-relaxed">{provider.eligibility}</p>
                </TooltipContent>
              </Tooltip>
            </div>)}
        </div>

        <div className="mt-12 text-center">
          <p className="text-foreground-dark/70 text-sm max-w-2xl mx-auto">
            Don't see your insurance provider? We also work with out-of-network benefits and can assist with reimbursement processes. Contact our team to discuss your options.
          </p>
        </div>
      </div>
    </section>;
}